import React, { useContext, useMemo } from "react";
import { Card } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuNotificationIcon from "../../utils/smu-notification-icon/SmuNotificationIcon";
import { COLOR_PRIMARY } from "../../constants/colors";
import { StoreContext } from "../../store/StoreContext";
import { useSortBy, useTable } from "react-table/dist/react-table.development";

const NotificationsTable = () => {
  const { alerts } = useContext(StoreContext);

  const columns = useMemo(
    () => [
      {
        Header: "Nombre",
        accessor: "title",
        Cell: ({ value }) => (
          <div className="cell my-2">
            <div className="d-flex align-items-center">
              <SmuNotificationIcon color="#FBAB33" />
              <span className="ms-3">{value}</span>
            </div>
          </div>
        ),
      },
      {
        Header: "Fecha Inicio",
        accessor: "start",
        Cell: ({ value }) => <div className="cell">{value}</div>,
      },
      {
        Header: "Fecha Termino",
        accessor: "end",
        Cell: ({ value }) => <div className="cell">{value}</div>,
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: alerts }, useSortBy);

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color={COLOR_PRIMARY} />
          <span className="fs-5 ms-3 me-auto">Centro de Notificaciones</span>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="table-responsive">
          <table
            {...getTableProps}
            className="table smu-table striped borderless"
          >
            <thead>
              {headerGroups.map((headerGroup, i) => (
                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, x) => (
                    <th
                      key={x}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div style={{ whiteSpace: "nowrap" }}>
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default NotificationsTable;
